import React from 'react';
import { FieldValues, FieldError } from 'react-hook-form';
import { twJoin } from 'tailwind-merge';
import { NormalInputProps } from './types/NormalInputProps';

// Reusable input component
function NormalInput<TFieldValues extends FieldValues>({
  label,
  name,
  register,
  errors,
  wrapperClass,
  registerOptions,
  ...rest
}: NormalInputProps<TFieldValues>) {
  const error = errors?.[name as keyof typeof errors] as FieldError | undefined;

  return (
    <div>
      <label htmlFor={name} className="text-sm font-bold">
        {label}
      </label>
      <div
        className={twJoin(
          'my-1 flex  items-center gap-2 rounded-sm border',
          error ? 'border-red/70' : 'border-neutral-15 ',
          wrapperClass,
        )}
      >
        <input
          {...register(name, registerOptions)}
          id={name}
          className="placeholder:text-neutral-50 focus:outline-none"
          {...rest}
        />
      </div>
      {error && <p className="text-sm text-red">{error.message}</p>}
    </div>
  );
}

export default NormalInput;
